import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../../src/config";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(false);

  //. handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMsg("");

    if (!password.trim() || !confirmPassword.trim()) {
      setError("Both password fields are required");
      return;
    }

    if (password !== confirmPassword) {
      //  setError("Passwords do not match");
      toast.error("Passwords do not match");  
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}auth/resetpassword/${token}`,
        { password }
      );

      if (response.data?.message) {
        setSuccessMsg("✅ Password reset successful! Redirecting to login...");
        setTimeout(() => navigate("/login"), 2000);
      } else {
        setError(response.data.message || "Unable to reset password");
      }
    } catch (err) {
      console.error("Reset password error:", err);
      setError(err.response?.data?.message || "Unable to reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="logincontainer">
      <div className="container">
        <div className="row justify-content-center">
          {/* Left side */}
          <div className="col-xxl-5 col-xl-4 col-lg-6 col-md-5 col-sm-12 col-12 align-self-center">
            <div className="logintextbox">
              <div className="loginheading">Remembered your password?</div>
              <p>Sign in with your account credentials.</p>
              <Link to="/login" className="theme-btn signupbtn">
                Sign In
              </Link>
            </div>
          </div>

          {/* Right side */}
          <div className="col-xxl-5 col-xl-5 col-lg-6 col-md-7 col-sm-12 col-12 align-self-center">
            <div className="loginbox">
              <div className="loginheading">Reset Password</div>
              <p>Enter your new password and confirm it below.</p>

              <form onSubmit={handleSubmit}>
                {/* New Password */}
                <div className="form-group">
                  <div className="formgroupinner">
                    <i className="fa fa-key"></i>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="New Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                </div>

                {/* Confirm Password */}
                <div className="form-group">
                  <div className="formgroupinner">
                    <i className="fa fa-lock"></i>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Confirm Password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </div>
                </div>

                {/* Error / Success */}
                {error && <small className="text-danger">{error}</small>}
                {successMsg && (
                  <div className="alert alert-success">{successMsg}</div>
                )}

                <button
                  className="theme-btn loginbtn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Reset Password"}
                </button>

                <div className="tex-start mt-3">
                  <div className="row gx-1 align-items-center">
                    <div className="col-12 text-end">
                      <Link to="/login" className="text-muted">
                        Back to Login
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
